import { defineMessages } from 'react-intl';

export default defineMessages({
    ENTResidentialQualificationTitle: {
        id: 'ent.quoteandbind.wizard.residential.Qualification.Title',
        defaultMessage: 'Qualification',
    },
    ENTResidentialQualificationPolicyTypeLabel: {
        id: 'ent.quoteandbind.wizard.residential.Qualification.PolicyType.Label',
        defaultMessage: 'Policy Type',
    },
    ENTResidentialQualificationPolicyTypePlaceholder: {
        id: 'ent.quoteandbind.wizard.residential.Qualification.PolicyType.Placeholder',
        defaultMessage: '--Please select--', // DE15916
    },
    TWIAResidentialQualificationElegibilityTitle: {
        id: 'tfpa.quoteandbind.wizard.residential.TWIA.Qualification.Elegibility',
        defaultMessage: 'TWIA General Eligibility',
    },
    TWIAResidentialQualificationPropertyTitle: {
        id: 'tfpa.quoteandbind.wizard.residential.TWIA.Qualification.Property',
        defaultMessage: 'TWIA Property Eligibility',
    },
    ENTResidentialQualificationElegibilityErrorTitle: {
        id: 'ent.quoteandbind.wizard.residential.Qualification.Error.Elegibility',
        defaultMessage: 'Eligibility Error',
    },
    // US26877 handle prequal warnings
    ENTResidentialQualificationElegibilityWarningTitle: {
        id: 'ent.quoteandbind.wizard.residential.Qualification.Warning.Elegibility',
        defaultMessage: 'Quote Warning Message',
    },
    // US26878 show the correct property eligiblity message
    TFPAResidentialQualificationPropertyTitle: {
        id: 'tfpa.quoteandbind.wizard.residential.Qualification.Property',
        defaultMessage: 'TFPA Property Eligibility',
    },
    // DE15920
    required: {
        id: 'tfpa.quoteandbind.wizard.residential.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})
